import React, { Component } from "react";
import styles from "./DealerReporting.module.scss";
import { Grid } from "@material-ui/core";
import Item from "../../../../shared/item/Item";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import SortData from "../../../../utils/SortUtil";
import { withTranslation } from "react-i18next";
import DownloadButtonV2 from "../../../../shared/buttons/DownloadButtonV2";
import { base64FileDownload } from "../../../../utils/FileDownloadUtil";
import { logMsg } from "../../../../common/Logger";
import DealerReportingClient from "../../../../shared/clients/DealerReportingClient";

class DealerReporting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortKey: null,
      sortDirection: null,
      reports: [
        {
          key: "report1",
          name: this.props.t("dealerReporting.report1Name"),
          description: this.props.t("dealerReporting.report1Description"),
          downloadLink: this.downloadOrderStatusReport.bind(this),
        },
      ],
    };
  }

  downloadOrderStatusReport = (report) => {
    this.props.hideOrShow(true);
    DealerReportingClient.downloadOrderStatusReportInXlsx(
      this.props.user,
      this.props.lang
    )
      .then((res) => {
        const filename = this.props.t(report.description) + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  sortColumns = (sortByCol) => {
    let sortDir = "DSC";
    if (sortByCol === this.state.sortKey) {
      sortDir = this.state.sortDirection === "ASC" ? "DSC" : "ASC";
    }
    const that = this;
    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      this.state.reports,
      function (sortedData) {
        that.setState({
          sortDirection: sortDir,
          sortKey: sortByCol,
          reports: sortedData,
        });
      }
    );
  };

  render() {
    return (
      <>
        <Grid container className={`pagePadding ${styles.gridHeader}`}>
          <Grid
            item
            md={3}
            className={styles.typeHeader}
            onClick={() => this.sortColumns("name")}
          >
            <Item value={this.props.t("dealerReporting.type")} />
            <span className={styles.sorting}>
              <SortingIcon
                currentKey="name"
                sortKey={this.state.sortKey}
                sortDirection={this.state.sortDirection}
              />
            </span>
          </Grid>
          <Grid
            item
            md={7}
            className={styles.typeHeader}
            onClick={() => this.sortColumns("description")}
          >
            <Item value={this.props.t("dealerReporting.document")} />
            <span className={styles.sorting}>
              <SortingIcon
                currentKey="description"
                sortKey={this.state.sortKey}
                sortDirection={this.state.sortDirection}
              />
            </span>
          </Grid>
          <Grid item md={2} className={styles.actionHeader}>
            <Item value={this.props.t("dealerReporting.action")} />
          </Grid>
        </Grid>

        {this.state.reports.map((report) => (
          <React.Fragment key={report.key}>
            <Grid
              container
              className={`pagePaddingLeft pagePaddingRight ${styles.gridBody}`}
            >
              <Grid item md={3} className={styles.colType}>
                <div>{report.name}</div>
              </Grid>
              <Grid item md={7} className={styles.colDocument}>
                <div>{report.description}</div>
              </Grid>
              <Grid item md={2} className={`${styles.end}`}>
                <DownloadButtonV2
                  download={() => report.downloadLink(report)}
                  text={this.props.t("dealerReporting.download")}
                />
              </Grid>
            </Grid>
          </React.Fragment>
        ))}
      </>
    );
  }
}

export default withTranslation("emp")(DealerReporting);
